export default function initializeBannerClickTracking() {
    document.querySelectorAll('.banner-click-tracker').forEach(function (link) {
        link.addEventListener('click', function () {
            const bannerId = link.dataset.bannerId;
            const bannerName = link.dataset.bannerName || '';

            if (!bannerId) {
                return;
            }

            const endpoint = window.wpApiSettings.root + 'venti/v1/banner-click/' + bannerId;

            fetch(endpoint, {
                method: 'POST',
                headers: { 'X-WP-Nonce': window.wpApiSettings.nonce },
                keepalive: true,
            });

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'banner_click',
                banner_id: bannerId,
                banner_name: bannerName,
            });
        });
    });
}
